import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import useCustomizationContext from "../../../../hooks/useCustomizationContext";
import { ReactComponent as IconCheck } from "../../../../icons/16x16/check.svg";
import { ReactComponent as IconX } from "../../../../icons/16x16/x.svg";
import {
  getCoverFilteredPages,
  getNoCoverDefinitions,
} from "../../../../utils/customization/cover";
import { isLargeSize, isSmallSize } from "../../../../utils/customization/device";
import { findLocalizedContent } from "../../../../utils/customization/localized";
import {
  findPageDescription,
  getPageLabel,
  getPagePosition,
} from "../../../../utils/customization/page";
import ButtonSmily from "../../../atoms/ButtonSmily";
import Link from "../../../atoms/Link";
import "./style.scss";

interface Props {
  onCancel: (event: MouseEvent) => void;
  onValidate: (event: MouseEvent) => void;
  pageKey: string;
  elementPlaceDetails?: string;
}

const EditorsValidationHeader: FunctionComponent<Props> = ({
  elementPlaceDetails,
  onCancel,
  onValidate,
  pageKey,
}) => {
  const intl = useIntl();
  const {
    configuration,
    content,
    template,
    ui: { pagesConfigMapping },
  } = useCustomizationContext();

  const pageDefinitions = getNoCoverDefinitions(template.pageDefinitions);
  const noCoverPageContents = getCoverFilteredPages(content.pages, pageDefinitions);
  const pageNumber = getPagePosition(noCoverPageContents, pageKey);

  const { label, translationId } = getPageLabel(configuration, template.templateType);
  let pageLabel = `${label ? label : intl.formatMessage({ id: translationId })} ${pageNumber}`;

  const localizedDescription = findPageDescription(pageKey, pagesConfigMapping);
  if (localizedDescription && localizedDescription.length > 0) {
    const forcedDescriptionContent = findLocalizedContent(localizedDescription, content.locale);
    pageLabel = forcedDescriptionContent.content;
  }

  return (
    <div className="EditorsValidationHeader">
      {isSmallSize() ? (
        <Link onClick={onCancel} size="m">
          <IconX />
        </Link>
      ) : (
        <ButtonSmily onClick={onCancel} size={isLargeSize() ? "s" : "xs"} type="tertiary">
          {intl.formatMessage({ id: "kustom_ConfirmModal_cancel" })}
        </ButtonSmily>
      )}

      <span className="EditorsValidationHeader-position">
        {pageNumber > 0 && <span>{pageLabel}</span>}
        {!!elementPlaceDetails && <span>{elementPlaceDetails}</span>}
      </span>

      <ButtonSmily
        icon={<IconCheck />}
        iconPosition={isSmallSize() ? "alone" : "left"}
        onClick={onValidate}
        size={isLargeSize() ? "s" : "xs"}
        type="primary"
      >
        {!isSmallSize() && intl.formatMessage({ id: "kustom_EditableBookTitle_validate" })}
      </ButtonSmily>
    </div>
  );
};

export default EditorsValidationHeader;
